import styled from 'styled-components';
import { grey } from 'styles/Colors';

export const NoDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 215px;
  font-size: 13px;
  color: ${grey};
`;
